export const defaultPauseReasons = {
  LOGIN: '100',
  NOT_ANSWERED_PAUSE: '101',
} as const;
